function Imprint() {
  return (
    <div className="container mx-auto my-8 px-4">
      <h2 className="text-4xl font-bold mb-6 text-slate-800">Impressum</h2>

      <div className="prose max-w-4xl text-slate-700">
        <section className="mb-8">
          <h3 className="text-2xl font-semibold mb-4 text-slate-800">
            Angaben gemäß § 5 TMG
          </h3>
          <p className="mb-2">Lisa Fuchsen</p>
          <p className="mb-2">Systemische Beratung</p>
          <p className="mb-2">Dauner Straße 2</p>
          <p className="mb-2">54516 Wittlich</p>
        </section>

        <section className="mb-8">
          <h3 className="text-2xl font-semibold mb-4 text-slate-800">
            Kontakt
          </h3>
          <p className="mb-2">E-Mail: stepintochange.withlisa@gmail.com</p>
        </section>

        <section className="mb-8">
          <h3 className="text-2xl font-semibold mb-4 text-slate-800">
            Berufsbezeichnung und berufsrechtliche Regelungen
          </h3>
          <p className="mb-4">Berufsbezeichnung: Systemische Beraterin (SG)</p>
        </section>

        <section className="mb-8">
          <h3 className="text-2xl font-semibold mb-4 text-slate-800">
            Streitschlichtung
          </h3>
          <p className="mb-4">
            Die Europäische Kommission stellt eine Plattform zur
            Online-Streitbeilegung (OS) bereit:
            https://ec.europa.eu/consumers/odr/. Unsere E-Mail-Adresse finden
            Sie oben im Impressum.
          </p>
          <p className="mb-4">
            Wir sind nicht bereit oder verpflichtet, an
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Imprint;
